import { useEffect, useMemo, useState } from "react";
import DocumentTitle from "react-document-title";
import { useTranslation } from "react-i18next";

import { ErrorCheckWrapper } from "./routes";

import LoadingModal from "pstat-design-system/modal/LoadingModal";
import { withLabelContext } from "pstat-anywhere/context_providers/LabelContext";

export const PageTitleWrapper = withLabelContext(
  ({ children, labels, documentName = "", titleKey }) => {
    const { t } = useTranslation();
    const parsedLabels = useMemo(() => ({ ...labels, documentName }), [
      documentName,
      labels
    ]);

    return (
      <DocumentTitle title={t(titleKey, parsedLabels)}>
        {children}
      </DocumentTitle>
    );
  }
);

export const LoadingPage = () => {
  const { t } = useTranslation();
  return <LoadingModal isOpen={true} text={t("loading")} />;
};

export const PageWrapper = ({
  component: Component,
  documentName: documentNameProp = "",
  queryName,
  showLoading,
  titleKey,
  ...props
}) => {
  const [pageTitle, setPageTitle] = useState(documentNameProp);

  useEffect(() => {
    if (!pageTitle && documentNameProp) {
      setPageTitle(documentNameProp);
    }
  }, [documentNameProp, pageTitle]);

  if (showLoading) {
    return <LoadingPage />;
  }

  return (
    <PageTitleWrapper titleKey={titleKey} documentName={pageTitle}>
      <ErrorCheckWrapper queryName={queryName} {...props}>
        <Component {...props} setPageTitle={setPageTitle} />
      </ErrorCheckWrapper>
    </PageTitleWrapper>
  );
};
